"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M10 0l3.1 6.6 6.9 1-5 5.1 1.2 7.3-6.2-3.4L3.8 20 5 12.7 0 7.6l6.9-1z"];
//# sourceMappingURL=star.js.map